import { useState, useEffect } from 'react';
import { execSeatableSql } from './seatable.js';
import { ToggleButton } from 'react-bootstrap';
import ArtifactSet from './artifactset.js';
import Footer from './footer.js';
import TopHeader from './topheader.js';
import { Helmet } from "react-helmet";

function Insights(props) {
    const [data, setData] = useState(null);
    const [typeData, setTypeData] = useState(null);
    const [capabilityData, setCapabilityData] = useState(null);
    const [industryData, setIndustryData] = useState(null);

    const [showFilters, setShowFilters] = useState(false);
    const [toggleAllTypes, setToggleAllTypes] = useState(true);
    const [toggleAllCapabilities, setToggleAllCapabilities] = useState(true);
    const [toggleAllIndustries, setToggleAllIndustries] = useState(true);

    useEffect(() => {
        async function fetchData() {
            setData(null);
            setTypeData(null);
            setCapabilityData(null);
            setIndustryData(null);

            try {
                const sql = `SELECT * FROM \`Artifact\` WHERE \`Disable\` IS NOT TRUE AND NOT ISEMPTY(\`Artifact Type\`) ORDER BY \`Artifact Rank\``;
                const rows = await execSeatableSql(sql);
                setData(rows && rows.results);

                const artiTypeRows = rows && rows.results.map(e => e['Artifact Type'][0].display_value);
                const artiTypeSet = [...new Set(artiTypeRows)];
                const artiCapRows = rows && rows.results.map(e => e['Subpages'].map(item => item.display_value));
                const artiCapSet = [...new Set(artiCapRows.flat())];

                const typeSql = `SELECT \`Desc\`, TRUE as \`Checked\` FROM \`Artifact Type\` ORDER BY \`Rank\``;
                const typeRows = await execSeatableSql(typeSql);
                setTypeData(typeRows && typeRows.results.filter(row => artiTypeSet.includes(row.Desc)));

                const capabilitySql = `SELECT \`Desc\`, TRUE as \`Checked\` FROM \`Subpages\` WHERE \`IsPublish\` IS TRUE AND \`CapabilityType\` = 'Subpages' ORDER BY \`Rank Order\``;
                const capabilityRows = await execSeatableSql(capabilitySql);
                setCapabilityData(capabilityRows && capabilityRows.results.filter(row => artiCapSet.includes(row.Desc)));

                const industrySql = `SELECT \`Desc\`, TRUE as \`Checked\` FROM \`Subpages\` WHERE \`IsPublish\` IS TRUE AND \`CapabilityType\` = 'Industry' ORDER BY \`Rank Order\``;
                const industryRows = await execSeatableSql(industrySql);
                setIndustryData(industryRows && industryRows.results.filter(row => artiCapSet.includes(row.Desc)));
            } catch (err) {
                // setError(err);
            }
        }
        fetchData();
    }, []);

    function handleToggleAllTypes() {
        const updatedTypeData = typeData && typeData.map(item => {return {...item, Checked: !toggleAllTypes}});
        setTypeData(updatedTypeData);
        setToggleAllTypes(!toggleAllTypes);
    }

    function handleToggleAllCapabilities() {
        const updatedCapabilityData = capabilityData && capabilityData.map(item => {return {...item, Checked: !toggleAllCapabilities}});
        setCapabilityData(updatedCapabilityData);
        setToggleAllCapabilities(!toggleAllCapabilities);
    }

    function handleToggleAllIndustries() {
        const updatedIndustryData = industryData && industryData.map(item => {return {...item, Checked: !toggleAllIndustries}});
        setIndustryData(updatedIndustryData);
        setToggleAllIndustries(!toggleAllIndustries);
    }

    function toggleArtifactType(e) {
        const eDesc = e.currentTarget.dataset.desc;
        const updatedTypeData = typeData && typeData.map(item => { return (item.Desc === eDesc) ? {...item,  Checked: !item.Checked} : item });
        setTypeData(updatedTypeData);
    }

    function toggleArtifactCapability(e) {
        const eDesc = e.currentTarget.dataset.desc;
        const updatedCapabilityData = capabilityData && capabilityData.map(item => { return (item.Desc === eDesc) ? {...item,  Checked: !item.Checked} : item });
        setCapabilityData(updatedCapabilityData);
    }

    function toggleArtifactIndustry(e) {
        const eDesc = e.currentTarget.dataset.desc;
        const updatedIndustryData = industryData && industryData.map(item => { return (item.Desc === eDesc) ? {...item,  Checked: !item.Checked} : item });
        setIndustryData(updatedIndustryData);
    }

    function filterArtifacts(artifactType) {
        if ((toggleAllCapabilities && toggleAllIndustries))
            return data.filter(row => (row['Artifact Type'][0].display_value === artifactType))
        else 
            return data.filter(row => (row['Artifact Type'][0].display_value === artifactType) && 
                                      (row['Subpages'].map(e => e.display_value).some(artiCap => ([...capabilityData??[], ...industryData??[]].filter(capRow => capRow.Checked).map(capRow => capRow.Desc).includes(artiCap))))
                            )
    }

    function toggleFilters() {
        setShowFilters(!showFilters)
    }

    return (<>
        <TopHeader MenuLevel="Insights" />
        <Helmet>
            <title>{props.metaTitle ?? props.metaTitle}</title>
            <meta name="description" content={props.metaDescription || ""} />
        </Helmet>
        {data ? (<>
        <div className="section-header d-flex flex-row">
            <FilterBox 
                title="Artifact Type"
                boxSize="30%"
                showFilters={showFilters}
                toggleFilters={toggleFilters}
                toggleAll={toggleAllTypes}
                handleToggleAll={handleToggleAllTypes}
                buttonData={typeData}
                toggleArtifact={toggleArtifactType}
            />
            <FilterBox 
                title="Capabilities"
                boxSize="35%"
                showFilters={showFilters}
                toggleFilters={toggleFilters}
                toggleAll={toggleAllCapabilities}
                handleToggleAll={handleToggleAllCapabilities}
                buttonData={capabilityData}
                toggleArtifact={toggleArtifactCapability}
            />
            <FilterBox 
                title="Industries"
                boxSize="35%"
                showFilters={showFilters}
                toggleFilters={toggleFilters}
                toggleAll={toggleAllIndustries}
                handleToggleAll={handleToggleAllIndustries}
                buttonData={industryData}
                toggleArtifact={toggleArtifactIndustry}
            />
        </div>
        {typeData && typeData.filter(typeRow => typeRow.Checked).map(typeRow => { return (<>
            <ArtifactSet showCapabilities={true} artifacts={filterArtifacts(typeRow.Desc)} />
        </>)})}
        </>) : ''}
        <Footer />
    </>)
}

function FilterBox(props) {
    return (
        <div className="d-none d-md-flex flex-column" style={{border: "1px solid var(--bg-card)", width: `${props.boxSize}`}}>
            <div className="d-flex flex-row my-3 fs-5 fw-bold" onClick={props.toggleFilters}><span className="mx-auto">{props.title}</span><i className={`me-3 bi ${props.showFilters ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i></div>
            {props.showFilters ? (
            <div className="d-flex flex-row flex-wrap justify-content-center">
                <ToggleButton type="checkbox" variant="outline-primary" className="rounded me-2 mb-2 px-2" checked={props.toggleAll} onClick={props.handleToggleAll}><i className={`me-1 bi bi-check ${props.toggleAll ? '' : 'd-none'}`}></i>All</ToggleButton>
                {props.buttonData && props.buttonData.map((item, index) => { return (
                    <ToggleButton key={index} type="checkbox" variant="outline-primary" data-desc={item.Desc} className="rounded me-2 mb-2 px-2" checked={item.Checked} onClick={props.toggleArtifact}><i className={`me-1 bi bi-check ${item.Checked ? '' : 'd-none'}`}></i>{item.Desc}</ToggleButton>
                )})}
            </div>
            ) : ''}
        </div>
    )
}

export default Insights;